import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerItemKeys } from '../registerItemKeys'
import {
  IRegisterItem,
  RegisterItem,
} from '@core/entities/register/RegisterItem'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const transform = (response: IRegisterItem) => RegisterItem.new(response)

export const useGetRegisterItem = (
  payload: RequestTypes['getRegisterItemDetails'],
  options?: UseQueryOptions<IRegisterItem, RequestErrorType, RegisterItem>,
) => {
  return useQuery({
    ...registerItemKeys.byId(payload),
    select: transform,
    ...options,
  })
}
